// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CeremonyModal_checkboxContainer__r2WHD"};